import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getAssetsToSellTotalForDrawdown, ShouldDisplayItfcChargesMessage } from "./Helper/DrawdownDetailHelper";
import { SectionHeader } from "../../SharedComponents";
import { processTypeEnum } from "../../Resource/Contents";
import { ChooseAssetsToSellFor } from "./Resource/Contents";
import { MoneyHelper } from "../../../../../../Shared/Common/MoneyHelper";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { getAssetsToSellTotalForIncome } from "../IncomePaymentDetails/Helper/IncomePaymentHelper";

interface IChooseAssetsToSellProps extends IProcessComponentProps {
    data: DrawdownModel;
    tableKey: string;
    sectionHeader?: string;
    processType?: processTypeEnum;
    reason?: ChooseAssetsToSellFor;
}

interface IChooseAssetsToSellState {}

export class ChooseAssetsToSell extends ProcessComponent<IChooseAssetsToSellProps, IChooseAssetsToSellState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.data.IsAcrossAllAssets == null) {
            this.props.onChange({ IsAcrossAllAssets: true });
        }
    }

    getSectionHeader() {
        const { data, reason } = this.props;
        const defaultHeader = "Choose assets to sell";
        if (reason === ChooseAssetsToSellFor.Income) {
            if (data?.DrawdownType === DrawdownType.Regular) {return defaultHeader;}
            else
                {return `Choose assets to sell to pay income (${MoneyDisplayHelper.FromatMoneyDisplay(
                    getAssetsToSellTotalForIncome(data),
                    MoneyHelper.getDefaultCurrency()
                )})`;}
        } else {
            return defaultHeader;
        }
    }

    getIsAcrossAll() {
        const { data, reason } = this.props;
        if (reason === ChooseAssetsToSellFor.Income) {
            return isNullOrEmpty(data?.IncomeDisinvestmentAllocations);
        }
        return data?.IsAcrossAllAssets == true;
    }

    public render(): JSX.Element {
        const { data, onChange, sectionHeader, processType, reason } = this.props;
        const shouldDisplayItfcChargesMessage = ShouldDisplayItfcChargesMessage(processType, reason);
        return (
            <>
                {SectionHeader(sectionHeader ? sectionHeader : this.getSectionHeader())}
                {shouldDisplayItfcChargesMessage && (
                    <p>
                        {data?.DrawdownType != DrawdownType.Regular ? (
                            <>{`Disinvestment to pay PCLS and charges (${MoneyDisplayHelper.getMoneyFormat({
                                Amount: getAssetsToSellTotalForDrawdown(data),
                                Currency: CurrencyCode.GBP,
                            })})`}</>
                        ) : (
                            `Disinvestment to pay drawdown and charges`
                        )}
                    </p>
                )}

                <RadiosEditor
                    options={[true, false]}
                    label={"Choose asset selection method"}
                    getText={(v) => (v ? "Proportionally across all assets" : "From specified assets")}
                    onChange={(v) => onChange({ IsAcrossAllAssets: v, [this.props.tableKey]: [] })}
                    tooltip={
                        "If there is insufficient value in an asset at the time of the sale, we will default to disinvesting proportioanlly from the assets selected."
                    }
                    cssWrapper={"rg-inline mb-10"}
                    selected={this.getIsAcrossAll()}
                />
            </>
        );
    }
}
